import { FlaskConical, History, Map } from "lucide-react";
import { ActionButtonConfig } from "./types";

// Button configuration array - Open/Closed Principle (easy to extend)
export const ACTION_BUTTONS: ActionButtonConfig[] = [
  {
    id: 8,
    label: "Mapping",
    icon: Map
  },
  {
    id: 11,
    label: "History",
    icon: History
  },
  {
    id: 9,
    label: "Simulation",
    icon: FlaskConical
  }
];
